import { Component, Injector, OnInit } from '@angular/core';
import { DialogAbstractComponent } from '../dialogs/dialog.class';

@Component({
  selector: 'app-welcome-msg-to-corporate-user',
  templateUrl: './welcome-msg-to-corporate-user.component.html',
  styleUrls: ['./welcome-msg-to-corporate-user.component.scss'],
})
export class WelcomeMsgToCorporateUserComponent extends DialogAbstractComponent implements OnInit {
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {}
  close() {
    this.closeDialog(false);
  }
}
